import styled from "styled-components";

interface INavButtonProps {
  isDisabled: boolean;
}
export const NavButton = styled.span<INavButtonProps>`
  width: 54px;
  height: 100%;
  display: flex;
  cursor: pointer;
  user-select: none;
  align-items: center;
  justify-content: center;
  transition: all ease-in-out 0.3s;
  opacity: ${({ isDisabled }) => (isDisabled ? 0.5 : 1)};

  &:hover {
    background: rgba(245, 245, 245, 0.1);
  }

  svg {
    filter: drop-shadow(0px 0px 10px rgba(0, 0, 0, 0.3));
  }
`;
